import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.API_URL || '',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

export const resource = parameters => {
  const { url, method, data, headers, timeout } = parameters;
  return instance.request(url, {
    method,
    headers: {
      ...headers,
    },
    body: JSON.stringify(data),
    ...(timeout && { timeout }),
  });
};

export default {
  resource,
};
